import { Button, Typography } from '@altibox/design-system-component-lib';
import { Link } from 'react-router-dom';
import { styled, css } from 'styled-components';

import { Container } from 'src/components/container';
import { Image } from 'src/components/image';
import { Link as ExternalLink } from 'src/components/link';
import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorSecondary050, colorSecondary800, colorSecondary900 } from 'src/styles/colors';
import { focus } from 'src/styles/mixins';
import { spacing2 } from 'src/styles/spacing';

// FIXME find a solution for container width
export const StyledContainer = styled(Container)`
  display: flex;
  height: 100%;
  align-items: center;
`;

export const StyledArrowLeftIcon = styled(Image)`
  /* stylelint-disable-next-line declaration-no-important */
  margin-right: 0 !important;
`;

export const StyledBreadcrumb = styled.div`
  height: 48px;

  @media (min-width: ${breakpointLargeTablet}) {
    height: 72px;
    background: ${colorSecondary050};
  }
`;

export const StyledLinkContainer = styled.div`
  color: ${colorSecondary900};
  font-weight: bold;
  font-size: 20px;

  &:not(:last-child)::after {
    content: '/';
    padding: 0 ${spacing2};
  }
`;

export const StyledButton = styled(Button)`
  margin: 0;
  padding: 0;
`;

const commonLinkStyles = css`
  color: ${colorSecondary900};
  font-weight: bold;
  text-decoration: none;
  border-bottom: 2px solid ${colorSecondary900};
  padding-bottom: 2px;

  &:hover {
    color: ${colorSecondary800};
    border-bottom: 2px solid ${colorSecondary800};
  }
`;

export const StyledText = styled(Typography)`
  font-weight: bold;
`;

export const StyledExternalLink = styled(ExternalLink)`
  ${commonLinkStyles};
`;

export const StyledLink = styled(Link)`
  font-size: 18px;
  ${focus};
  ${commonLinkStyles};
`;
